"use client";

import Image from "next/image";
import ScrollReveal from "@/components/common/ScrollReveal";
import BorderedHeading from "@/components/common/BorderedHeading";
import CareerCard from "@/components/common/CareerCard";

interface JobPosition {
  id: string;
  title: string;
  location: string;
  slug: string;
}

const jobPositions: JobPosition[] = [
  {
    id: "frontend",
    title: "Frontend Developer",
    location: "Ho Chi Minh City",
    slug: "frontend-developer",
  },
  {
    id: "backend",
    title: "Backend Developer (PHP)",
    location: "Ho Chi Minh City",
    slug: "php-developer",
  },
  {
    id: "exploit",
    title: "Exploit Developer",
    location: "Ho Chi Minh City",
    slug: "exploit-developer",
  },
  {
    id: "offensive",
    title: "Offensive Security Engineer",
    location: "Ho Chi Minh City",
    slug: "offensive-security-engineer",
  },
  {
    id: "mobile",
    title: "Mobile Application Pentest",
    location: "Ho Chi Minh City",
    slug: "mobile-application-pentest",
  },
  {
    id: "web-security",
    title: "Web Security Consultant",
    location: "Ho Chi Minh City",
    slug: "web-security-consultant",
  },
];

export default function Careers() {
  return (
    <section className="w-full px-4 sm:px-6 lg:px-8 pt-2 pb-12">
      <div className="w-full max-w-[1300px] mx-auto">
        <ScrollReveal direction="up">
          {/* Match Figma node 754:56378: text 644×112 left, chair group 348×327 right at x=804 (gap ~160px) */}
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10 md:gap-16 mb-12 md:mb-16">
            <p className="text-text-default text-[15px] md:text-base leading-[26px] md:leading-[28px] max-w-[644px] md:flex-1">
              At ECQ we are excited to have people joining our team. We are constantly looking for
              individuals who are enthusiast in what they do, be it programming, hacking, writing
              report, or developing exploit. Please check out our current open positions below.
            </p>
            <div className="relative w-[260px] sm:w-[300px] md:w-[348px] aspect-[348/327] md:flex-shrink-0 self-center md:self-start">
              {/* WE ARE HIRRING speech bubble at top-right (Figma: 172×52 at x=176, y=0) */}
              <div
                className="absolute bg-primary text-white font-semibold tracking-[0.5px] whitespace-nowrap z-10 flex items-center justify-center text-xs md:text-sm"
                style={{
                  top: 0,
                  left: `${(176 / 348) * 100}%`,
                  width: `${(172 / 348) * 100}%`,
                  height: `${(52 / 327) * 100}%`,
                  borderRadius: 6,
                }}
              >
                WE ARE HIRRING
                <span
                  aria-hidden
                  className="absolute left-2 -bottom-1.5 w-3 h-3 bg-primary rotate-45"
                />
              </div>
              {/* Chair illustration (Figma: 219×274 at x=0, y=53 within 348×327 group) */}
              <Image
                src="/images/Company/careers-chair.svg"
                alt=""
                width={219}
                height={274}
                className="absolute"
                style={{
                  top: `${(53 / 327) * 100}%`,
                  left: 0,
                  width: `${(219 / 348) * 100}%`,
                  height: `${(274 / 327) * 100}%`,
                }}
                unoptimized
                aria-hidden
              />
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={100}>
          <div className="flex items-center gap-4 mb-6">
            <BorderedHeading
              as="h2"
              variant="headline-4"
              className="text-white font-semibold whitespace-nowrap"
            >
              Open Positions
            </BorderedHeading>
            <div className="flex-1 h-px bg-white/15" />
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={150}>
          <div className="grid md:grid-cols-2 gap-4 md:gap-5">
            {jobPositions.map((job) => (
              <CareerCard
                key={job.id}
                title={job.title}
                location={job.location}
                href={`/company/careers/${job.slug}`}
              />
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
